<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { axiosGetPost } from '@router/axiosGetPost'
import StatusRq from '@/src/components/request/StatusRq'
import RightSidebar from '@/src/components/right-sidebar.vue'
import HideColumnsTable from '@components/datatablegn/HideColumnsTable'
import WaitingStatus from '@/src/components/WaitingStatus'
import UpdateTime from '@/src/components/request/UpdateTime'

export default {
  page: {
    title: 'Inland Requests',
  },
  components: {
    Layout,
    PageHeader,
    HideColumnsTable,
    StatusRq,
    WaitingStatus,
    UpdateTime,
  },
  data() {
    return {
      title: 'Inland Requests',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Inlands',
          active: false,
        },
        {
          text: 'Requests',
          active: false,
        },
      ],
      statusColor: {
        ['Pending']: '#f81538',
        ['Processing']: '#5527f0',
        ['Pending by Ticket']: '#ff5fa8',
        ['Imp Finished']: '#431b02',
        ['Pre-Review']: '#fd7300',
        ['Re-Processing']: '#0076ff',
        ['Review']: '#e07000',
        ['Done']: '#04950f',
      },
      equipmentColor: {
        //['DRY']: '#012586',
        ['/DRY']: '#012586',
        //['REEFER']: '#ad43ba',
        //['OPEN TOP']: '#9f9b45',
        //['FLAT RACK']: '#058b0a',
      },
      typeTable: 'inlands',
      tableData: [{ data: 'ok' }],
      loadingTable: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: null,
      sortDesc: false,
      fields: [],
      fieldList: [{ key: 'data' }],
      excludeFields: [],
      loadingData: false,
      rowId: null,

      modalErrorShow: false,
      modalError: false,
      modalComponent: 'changeStatus',
      modalTitle: 'Status',
      showModal: false,
    }
  },
  watch: {
    filter(newValue) {
      localStorage.setItem('searchInlandRequestList', newValue)
    },
  },
  computed: {
    rows() {
      return this.tableData.length
    },
  },
  created() {
    this.fetchData()
    this.totalRows = this.tableData.length
  },
  mounted() {
    const searchValue = localStorage.getItem('searchInlandRequestList')
    if (searchValue) {
      this.filter = searchValue
    }
  },
  methods: {
    fetchData() {
      this.loadingTable = true
      axiosGetPost('get', 'inlands/list').then((response) => {
        this.tableData = response.data
        this.fieldList = response.columns
        this.dateServer = response.date
        this.loadingTable = false
        return response
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
    },
    customFilterTable(row, filter) {
      const valuesRow = Object.values(row)
      const filters = filter.split(' ')
      let filtersFined = []
      filters.forEach((filterVal) => {
        valuesRow.filter((valRow) => {
          const valRowLC = String(valRow).toLowerCase()
          const filterValLC = String(filterVal).toLowerCase()
          if (
            valRowLC.includes(filterValLC) &&
            !filtersFined.includes(filterVal)
          ) {
            filtersFined.push(filterVal)
          }
        })
      })
      return filtersFined.length === filters.length
    },
    updateTableFieldsEmit(fields) {
      this.fields = fields
    },
    saveModal() {
      this.showModal = false
    },
    findIndex(id) {
      const valObj = this.tableData.findIndex(function(elem) {
        if (elem.id === id) return elem
      })
      return valObj
    },
    requestStatusMt(id) {
      this.loadingData = false
      this.modalErrorShow = false
      this.modalComponent = 'changeStatus'
      this.modalTitle = 'Status'
      this.showModal = true
      this.rowId = id
    },
    update_table_status(id, status, usernameLoad, lockedOptions) {
      const valueObj = this.findIndex(id)
      this.tableData[valueObj].status = status
      this.tableData[valueObj].usernameLoad = usernameLoad
      this.tableData[valueObj].lockedOptions = lockedOptions
      this.showModal = false
    },
    downloadFile(id, type) {
      console.log('id', id, 'type', type)
      const url =
        type == 'op' ? `/inlands/downloadOp/${id}` : `/inlands/download/${id}`

      axiosGetPost('get', url).then((response) => {
        if (response.success === true) {
          const link = document.createElement('a')
          link.setAttribute('target', '_blank')
          link.href = response.url
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          if (response.message) {
            this.$toastr.e(response.message)
          } else {
            this.$toastr.e('Error to download file.')
          }
        }
      })
    },
    reImportation(id) {
      this.loadingData = false
      this.modalErrorShow = false
      this.modalComponent = 'waitingImportationStatus'
      this.modalTitle = 'Re Importing'
      this.showModal = true
      this.rowId = id

      axiosGetPost('get', `/inlands/reImportation/${id}`).then((response) => {
        if (response.success === true) {
          this.$toastr.s(response.message)
        } else {
          this.$toastr.e(response.message)
        }
      })
    },
    redirectAfterImport() {
      this.fetchData()
      this.totalRows = this.tableData.length
      this.showModal = false
    },
    hideRequest(id) {
      this.$swal({
        title: `Are you sure you want to hide this Request Inland with ID ${id}? This action is irreversible.`,
        showCancelButton: true,
        confirmButtonColor: 'brown',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          this.loadingData = true
          axiosGetPost(
            'get',
            `/inlands/hideRequest/${id}`,
            {},
            'Hide Request Inland'
          ).then((response) => {
            if (response.success) {
              this.$toastr.s('Success. Request Hidden')
              this.fetchData()
            } else {
              this.$toastr.e('Attention. Error')
            }
            return response
          })
        } else {
          this.$swal('Cancelled')
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-md-2">
              <div class="col-sm-3 col-md-8 text-md-left">
                <h4 class="header-title mt-0 mb-1">Inland Requests List</h4>
              </div>
              <!--div class="col-sm-4 col-md-4 text-md-right">
                  <b-button
                    class="btn btn-primary col-md-5"
                    variant="primary"
                    @click="addNew"
                    >Add <i class="uil uil-plus"></i>
                  </b-button>
                </div-->
            </div>

            <div class="form-group row">
              <div class="col-md-12">
                <div class="d-flex mb-md-2">
                  <!-- Start Table **************-->
                  <div class="mr-auto">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Start Hide Columns **************-->
                  <div>
                    <HideColumnsTable
                      v-if="this.loadingTable === false"
                      :field-list-fth="fieldList"
                      :type-table="typeTable"
                      @updateTableFieldsEmit="updateTableFieldsEmit"
                    />
                  </div>
                  <!-- End Hide Columns **************-->
                  <!-- Search -->
                  <div>
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                  </div>

                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    striped
                    hover
                    :items="tableData"
                    :fields="fields"
                    responsive="sm"
                    :busy="loadingTable"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :filter-function="customFilterTable"
                    @filtered="onFiltered"
                  >
                    <template v-slot:table-busy>
                      <div
                        class="row align-items-center justify-content-center"
                        style="height: 150px"
                      >
                        <div class="col-12 col-md-8 text-center">
                          <b-spinner
                            label="Loading..."
                            variant="primary"
                            class="ml-3"
                          ></b-spinner>
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(company_user)="row">
                      <span
                        class="badge"
                        :class="`badge-tier-1`"
                        :title="`Tier 1`"
                        >{{ row.item.company_user }} <br />
                      </span>
                      <br />
                      <span
                        v-if="row.item.company_country !== null"
                        class="badge"
                        :class="`badge-country`"
                        :title="`Tier 1`"
                        style="color: #1DD792"
                        >{{ row.item.company_country }} <br />
                      </span>
                    </template>
                    <template v-slot:cell(actions)="row">
                      <div>
                        <b-dropdown
                          variant="success"
                          dropleft
                          class="ml-1 btn-sm"
                        >
                          <template slot="button-content">
                            <i
                              class="uil uil-angle-double-left"
                              style="color: #278c27"
                            ></i>
                            <i v-if="row.item.deleted_at == null">Options</i>
                            <i
                              v-else
                              style="color: #f81538"
                              title="Inland Deleted By Customer"
                              ><strong> Erased</strong></i
                            >
                          </template>
                          <b-dropdown-item
                            href="#"
                            style="color: #0a399a"
                            @click="downloadFile(row.item.id, 'client')"
                          >
                            <span style="color: rgb(1 38 113)"
                              ><i class="uil uil-cloud-download"></i>&nbsp;
                              &nbsp; Download File C.</span
                            >
                          </b-dropdown-item>
                          <b-dropdown-item
                            href="#"
                            style="color: #0a399a"
                            @click="downloadFile(row.item.id, 'op')"
                          >
                            <span style="color: rgb(20, 113, 1)"
                              ><i class="uil uil-cloud-download"></i>&nbsp;
                              &nbsp; Download File Op.</span
                            >
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="
                              ['Processing', 'Done'].includes(row.item.status)
                            "
                            href="#"
                            :to="{
                              name: 'goodandfails_inlands',
                              params: {
                                id: row.item.id,
                              },
                            }"
                          >
                            <span style="color: rgb(15, 118, 118)">
                              <i class="uil uil-atm-card"></i>
                              &nbsp; &nbsp; Good & Fail
                            </span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="['Processing'].includes(row.item.status)"
                            href="#"
                            :to="{
                              name: 'importation_inlands',
                              params: {
                                id: row.item.id,
                              },
                            }"
                          >
                            <span style="color: rgb(86 21 21)">
                              <i class="uil uil-file-check-alt"></i>
                              &nbsp; &nbsp; Import With File
                            </span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="['Processing'].includes(row.item.status)"
                            @click="reImportation(row.item.id)"
                          >
                            <span style="color: rgb(177, 108, 18)">
                              <i class="uil uil-file-check-alt"></i>
                              &nbsp; &nbsp; ReImport
                            </span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            href="#"
                            style="color: rgb(248, 21, 56)"
                            v-if="row.item.deleted_at != null"
                            @click="hideRequest(row.item.id)"
                          >
                            <span style="color: rgb(248, 21, 56)">
                              <i class="uil uil-eye-slash"></i>
                              &nbsp; &nbsp;Hide Request
                            </span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </template>
                    <template v-slot:cell(status)="row">
                      <!-- <b-button variant="success" @click="test(row.index)">chang</b-button> -->
                      <a
                        v-if="row.item.deleted_at === null"
                        href="#"
                        @click="requestStatusMt(row.item.id)"
                      >
                        <span
                          :style="{ color: statusColor[row.item.status] }"
                          style="font-weight: bold"
                          >{{ row.item.status }} <br />
                          <small
                            v-if="row.item.bc_rq_mappin_status === 1"
                            class="parpadea"
                            style="color: #c19b00"
                            >Incomplete mapping</small
                          >
                        </span>
                      </a>
                      <a
                        v-else-if="row.item.deleted_at !== null"
                        href="#"
                        title="Contract Deleted By Customer"
                      >
                        <span
                          :style="{ color: statusColor[row.item.status] }"
                          style="font-weight: bold"
                          >{{ row.item.status }}
                          <span
                            class="uil uil-lock-alt"
                            style="color: #f81538"
                          ></span
                          ><br />
                          <small style="color: #f81538"
                            >Inland Deleted</small
                          ></span
                        >
                      </a>
                    </template>
                    <template v-slot:cell(equipment)="row">
                      <a v-bind:title="row.item.equipment">
                        <span
                          :class="row.item.equipment"
                          :style="{ color: equipmentColor[row.item.equipment] }"
                          style="font-weight: bold"
                          >{{ row.item.equipment }}</span
                        >
                      </a>
                    </template>
                    <template v-slot:cell(time_elapsed)="row">
                      <span v-if="row.item.status !== 'Done'">
                        <UpdateTime
                          :date-time="row.item.created_at"
                          :date-server="dateServer"
                        />
                      </span>
                      <span v-else style=""
                        >{{ row.item.time_elapsed }} <br />
                      </span>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <strong
                      >Filtered {{ totalRows }} of {{ rows }} entries</strong
                    >
                    <div
                      class="
                          dataTables_paginate
                          paging_simple_numbers
                          float-lefts
                        "
                    >
                      <span>
                        <!--<i>Total Rows: {{ rows }}</i>-->
                      </span>
                    </div>
                  </div>
                  <div class="col">
                    <div
                      class="
                          dataTables_paginate
                          paging_simple_numbers
                          float-right
                        "
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Fin Table */******************************************************* */ -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <StatusRq
          v-if="modalComponent === 'changeStatus'"
          :request-id="rowId"
          mode="inlands"
          @update_table_row="update_table_status"
        />

        <WaitingStatus
          v-if="modalComponent === 'waitingImportationStatus'"
          :request-id="rowId"
          :reload-time="10"
          url="/inlands/getStatusTask/"
          @postevent="redirectAfterImport"
          has-post-event
        />

        <template v-slot:modal-footer>
          <b-button variant="light" @click="$refs.requestFcl.hide"
            >Close</b-button
          >
          <b-button
            v-if="
              loadingData === false &&
                modalErrorShow === false &&
                !['changeStatus'].includes(modalComponent)
            "
            variant="primary"
            @click="saveModal"
          >
            OK
          </b-button>
        </template>
      </b-modal>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style>
.table-responsive-list-menu {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

.badge-soft-warning {
  color: #c39411 !important;
  background-color: rgba(255, 190, 11, 0.2);
}

.badge-soft-success {
  color: #299a70 !important;
  background-color: rgba(67, 211, 158, 0.2);
}

.badge-tier-1 {
  color: #ffffff !important;
  background-color: #1f56d6;
}

.badge-tier-2 {
  color: #ffffff !important;
  background-color: #1f93d6;
}

.badge-tier-3 {
  color: #ffffff !important;
  background-color: #1dbfd7;
}
.badge-country {
  color: #ffffff !important;
  background-color: #1dd792;
}

.btn-success:hover {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.btn-success {
  color: #0014a2;
  background-color: #ffffff;
  border-color: #031b4e;
}

.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}
</style>
